import React, { useState, useEffect } from 'react';
import { shopContext } from '../contexts/aniplus';
import { withRouter } from 'react-router-dom';

import SeatReserveList from './SeatReserveList';
import SeatReserveDetail from './SeatReserveDetail';

const SeatReserveMy = (props) => {
  const { ticketCode, charImg, popupClose } = props.childProps;
  // const { socket } = props.childProps;
  const [orderCode, setOrderCode] = useState('');
  const [cnt, setCnt] = useState(0);
  const [param, setParam] = useState('');
  const [gPage, setGPage] = useState(1);

  const _showSeat = (orderCode) => {
    setOrderCode(orderCode);
  };
  const _setCnt = (cnt) => {
    setCnt(cnt);
  };
  const _setParam = (param) => {
    setParam(param);
  };

  return (
    <>
      {orderCode === '' ? (
        <SeatReserveList
          ticketCode={ticketCode}
          charImg={charImg}
          cnt={cnt}
          param={param}
          popupClose={popupClose}
          showSeat={_showSeat}
          setCnt={setCnt}
          setParam={setParam}
          gPage={gPage}
          setGPage={setGPage}
          // socket={socket}
        />
      ) : (
        <SeatReserveDetail
          orderCode={orderCode}
          ticketCode={ticketCode}
          charImg={charImg}
          cnt={cnt}
          param={param}
          popupClose={popupClose}
          showSeat={_showSeat}
          gPage={gPage}
          setGPage={setGPage}
          // socket={socket}
        />
      )}
    </>
  );
};

export default shopContext(withRouter(SeatReserveMy));
